var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../../store';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { PAX_TYPE_INFANT_CODE, BUSINESS_BRANDS, ANCILLARY_PRODUCT_GROUP_CODE_MEAL, EXTRAS_ANCILLARY_MEAL, ANCILLARY_PRODUCT_MEAL, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET, SPECIAL_CASE_MARKET_LANGUAGE_MAP } from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
var INDRAFlightDetailsMealsComponent = /** @class */ (function () {
    function INDRAFlightDetailsMealsComponent(sidebarService, route, router, store, ancillariesService, bookingService, bfmStorage, ibeAdminConfigService, bookingSearchService, storageService) {
        this.sidebarService = sidebarService;
        this.route = route;
        this.router = router;
        this.store = store;
        this.ancillariesService = ancillariesService;
        this.bookingService = bookingService;
        this.bfmStorage = bfmStorage;
        this.ibeAdminConfigService = ibeAdminConfigService;
        this.bookingSearchService = bookingSearchService;
        this.storageService = storageService;
        this.isAlive = true;
        this.passengers$ = this.store.select(fromStore.getMiniIBEPassengers);
        this.isLongHaul = false;
        this.reviewFlights = false;
        this.timeToThinkFlights = false;
        this.showAddButton = false;
        this.isBusinessBrand = false;
        this.stops = [];
        this.flightWithMealAncSegments = [];
        this.showMeal = true;
        this.selectedStop = '0';
        this.directFlight = false;
        this.flightsPage = false;
        this.flightsStopOverPage = false;
        this.flightsMultiCityPage = false;
        this.mealImagePerSegment = [];
        this.isSnack = false;
        this.hasSnack = [];
        this.hasStopover = false;
    }
    INDRAFlightDetailsMealsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.router.url.includes('/review-your-trip'))
            this.reviewFlights = true;
        if (this.router.url.includes('/time-to-think'))
            this.timeToThinkFlights = true;
        if (this.router.url.includes('/flights'))
            this.flightsPage = true;
        if (this.router.url.includes('/flights-stopover'))
            this.flightsStopOverPage = true;
        if (this.router.url.includes('/flights-multicity'))
            this.flightsMultiCityPage = true;
        this.brand = this.route.snapshot.paramMap.get('brand');
        this.passengers$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                // generate generic passenger list according to type and count
                _this.passengerList = _this.ancillariesService.INDRA_generateGenericPassengerList(value);
            }
        });
        // Note: There are three flows where this sidebar will be shown - flight search result page, review your trip page, and in time to think page
        if (this.reviewFlights || this.timeToThinkFlights) {
            this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
            var flightObj = this.bookingService.INDRA_getBookedFlight(this.flightIdentifier);
            this.flightIdentifierMeal = flightObj.idFlight;
            this.flight = this.bookingService.INDRA_getFlightRoute(flightObj);
            this.feature = this.bookingService.INDRA_getIncludedFeature(ANCILLARY_PRODUCT_GROUP_CODE_MEAL, this.flight.idFlight.toString(), '');
            this.INDRA_showAddButton(flightObj, this.flightIdentifier);
        }
        else {
            // get flight and feature object from the data obj passed into the sidebarservice
            var parameters = this.sidebarService.getSidebarParameters();
            if (parameters && parameters.length) {
                this.flight = parameters[0].flightInfo;
                this.feature = parameters[0].feature;
            }
        }
        var hasMeal;
        var ancillary;
        var segmentIndex = 0;
        var mealSegDetails = JSON.parse(sessionStorage.getItem('ancMealLabelSegments'));
        this.hasSnack = [];
        this.flight.listSegment.forEach(function (segment, index) {
            _this.hasSnack[index] = false;
            hasMeal = false;
            var segmentRoute = segment.departureAirport + '-' + segment.arrivalAirport;
            var isMealSegment = null;
            var isSnackSegment = null;
            if (mealSegDetails && mealSegDetails.length) {
                // determine meal availabilty per segment on availability page
                isMealSegment = mealSegDetails.find(function (detail) {
                    return detail.idSegment == segment.idInfoSegment
                        && detail.route === segmentRoute
                        && detail.flightId === _this.flight.idFlight
                        && _this.bookingSearchService.INDRA_getBrandCodeFromAmadeus(detail.fareFamily[0]) == _this.flight.options.brand;
                });
                hasMeal = isMealSegment ? true : false;
            }
            if (_this.flightsPage) {
                isSnackSegment = mealSegDetails.find(function (detail) {
                    return detail.idSegment == segment.idInfoSegment
                        && detail.route === segmentRoute
                        && detail.flightId === _this.flight.idFlight
                        && detail.hasSnack;
                });
                _this.hasSnack[index] = isSnackSegment ? true : false;
            }
            var mealSource = isMealSegment
                ? isMealSegment
                : isSnackSegment || null;
            if (hasMeal) {
                _this.stops.push({
                    label: segment.departureAirport + '-' + segment.arrivalAirport,
                    value: segmentIndex,
                    available: hasMeal,
                    anc: ancillary,
                    infoSeg: segment.idInfoSegment + '',
                    mealImageBySegment: mealSource ? mealSource.mealImageBySegment : {},
                    mealImage: mealSource ? mealSource.mealImage : '',
                });
            }
            else {
                _this.stops.push({
                    label: segment.departureAirport + '-' + segment.arrivalAirport,
                    value: segmentIndex,
                    available: _this.hasSnack[index],
                    anc: ancillary,
                    snack: _this.hasSnack,
                    infoSeg: segment.idInfoSegment + '',
                    mealImageBySegment: mealSource ? mealSource.mealImageBySegment : {},
                    mealImage: mealSource ? mealSource.mealImage : '',
                });
            }
            segmentIndex++;
        });
        this.directFlight = this.flight.listSegment.length > 1 ? false : true;
        this.isBusinessBrand = BUSINESS_BRANDS.includes(this.brand);
        this.isLongHaul = this.INDRA_isLongHaul();
        if (!this.flightsPage) {
            this.hasStopover = this.INDRA_checkStopovers();
        }
        this.INDRA_displayMealSegments();
        this.INDRA_displaySnackSegments();
        this.INDRA_selectedStop(0);
    };
    INDRAFlightDetailsMealsComponent.prototype.INDRA_selectedStop = function (event) {
        if (!this.directFlight || this.hasStopover) {
            if (this.stops[event] && !this.stops[event].available) {
                // if stop/segment selected has no meals,
                // update the passengerList input to show in included-per-passenger
                // the correct meal status
                this.passengerList = this.passengerList.map(function (pax) {
                    var newPax = __assign({}, pax, { ancillaryStatus: false });
                    return newPax;
                });
                this.showMeal = false;
            }
            else {
                this.passengerList = this.passengerList.map(function (pax) {
                    var newPax = __assign({}, pax, { ancillaryStatus: true });
                    return newPax;
                });
                this.showMeal = true;
            }
        }
        this.selectedStop = event;
    };
    INDRAFlightDetailsMealsComponent.prototype.INDRA_displayMealSegments = function () {
        var _this = this;
        if (this.reviewFlights || this.timeToThinkFlights) {
            var pnrDetailsRes_1 = this.bfmStorage.originalPNRDetailsResponse;
            var tripType = pnrDetailsRes_1.data.fare.tripType;
            var mealSegments_1 = [];
            var ancMealSegments_1 = [];
            var fareInfoSegments_1 = Object.keys(pnrDetailsRes_1['fare-information']);
            if (fareInfoSegments_1 && fareInfoSegments_1.length > 0) {
                fareInfoSegments_1.map(function (data) {
                    var ancSegments = Object.keys(pnrDetailsRes_1['fare-information'][data].ancillariesBySegment);
                    ancSegments.map(function (ancSeg) {
                        var ancIncludedList = pnrDetailsRes_1['fare-information'][data].ancillaries;
                        var ancSegData = pnrDetailsRes_1['fare-information'][data].ancillariesBySegment[ancSeg];
                        if (ancIncludedList && ancIncludedList.length > 0 && ancIncludedList.includes('MEALS')) {
                            if (ancSegData.length > 0 && ancSegData.includes('MEALS')) {
                                _this.mealImagePerSegment.push({ flightId: data, image: pnrDetailsRes_1['fare-information'][data].mealImageBySegment[ancSeg], type: "MEALS" });
                                if (fareInfoSegments_1.length == 1) {
                                    ancMealSegments_1.push(ancSeg);
                                }
                                else {
                                    ancMealSegments_1.push({
                                        flightId: data,
                                        segment: ancSeg
                                    });
                                }
                            }
                        }
                    });
                });
                switch (tripType) {
                    case 'R':
                        var tempMealSegments_1 = [];
                        ancMealSegments_1.map(function (res) {
                            if (_this.flightIdentifierMeal == res.flightId) {
                                if (res.flightId == '1') { //OUTBOUND
                                    pnrDetailsRes_1.data.fare.listOutbound.map(function (data) {
                                        if (data.listSegment.length > 1) {
                                            data.listSegment.map(function (seg) {
                                                if (res.segment.includes(seg.idInfoSegment.toString())) {
                                                    tempMealSegments_1.push(seg);
                                                }
                                            });
                                        }
                                    });
                                }
                                else { //INBOUND
                                    if (pnrDetailsRes_1.data.fare.inbound.listSegment.length > 1) {
                                        pnrDetailsRes_1.data.fare.inbound.listSegment.map(function (seg) {
                                            if (res.segment.includes(seg.idInfoSegment.toString())) {
                                                tempMealSegments_1.push(seg);
                                            }
                                        });
                                    }
                                }
                            }
                        });
                        mealSegments_1 = tempMealSegments_1;
                        break;
                    case 'O':
                        pnrDetailsRes_1.data.fare.listOutbound.map(function (data) {
                            data.listSegment.map(function (seg) {
                                if (ancMealSegments_1.includes(seg.idInfoSegment.toString())) {
                                    mealSegments_1.push(seg);
                                }
                            });
                        });
                        break;
                    case 'M':
                        pnrDetailsRes_1.data.fare.listOutbound.map(function (data) {
                            data.listSegment.map(function (seg) {
                                if (ancMealSegments_1.some(function (anc) { return anc.segment == seg.idInfoSegment.toString(); })) {
                                    mealSegments_1.push(seg);
                                }
                            });
                        });
                        break;
                    default: break;
                }
                this.mealSegmentsData = mealSegments_1;
                this.INDRA_updateStops(this.mealSegmentsData, "MEALS");
            }
        }
    };
    INDRAFlightDetailsMealsComponent.prototype.INDRA_displaySnackSegments = function () {
        var _this = this;
        if (this.reviewFlights || this.timeToThinkFlights) {
            var pnrDetailsRes_2 = this.bfmStorage.originalPNRDetailsResponse;
            var tripType = pnrDetailsRes_2.data.fare.tripType;
            var mealSegments_2 = [];
            var ancMealSegments_2 = [];
            var fareInfoSegments_2 = Object.keys(pnrDetailsRes_2['fare-information']);
            if (fareInfoSegments_2 && fareInfoSegments_2.length > 0) {
                fareInfoSegments_2.map(function (data) {
                    var ancSegments = Object.keys(pnrDetailsRes_2['fare-information'][data].ancillariesBySegment);
                    ancSegments.map(function (ancSeg) {
                        var ancIncludedList = pnrDetailsRes_2['fare-information'][data].ancillaries;
                        var ancSegData = pnrDetailsRes_2['fare-information'][data].ancillariesBySegment[ancSeg];
                        if (ancIncludedList && ancIncludedList.length > 0 && ancIncludedList.includes('SNACK')) {
                            if (ancSegData.length > 0 && ancSegData.includes('SNACK')) {
                                _this.mealImagePerSegment.push({ flightId: data, image: pnrDetailsRes_2['fare-information'][data].mealImageBySegment[ancSeg], type: "SNACK" });
                                if (fareInfoSegments_2.length == 1) {
                                    ancMealSegments_2.push(ancSeg);
                                }
                                else {
                                    ancMealSegments_2.push({
                                        flightId: data,
                                        segment: ancSeg
                                    });
                                }
                            }
                        }
                    });
                });
                switch (tripType) {
                    case 'R':
                        var tempMealSegments_2 = [];
                        ancMealSegments_2.map(function (res) {
                            if (_this.flightIdentifierMeal == res.flightId) {
                                if (res.flightId == '1') { //OUTBOUND
                                    pnrDetailsRes_2.data.fare.listOutbound.map(function (data) {
                                        if (data.listSegment.length > 1) {
                                            data.listSegment.map(function (seg) {
                                                if (res.segment.includes(seg.idInfoSegment.toString())) {
                                                    tempMealSegments_2.push(seg);
                                                }
                                            });
                                        }
                                    });
                                }
                                else { //INBOUND
                                    if (pnrDetailsRes_2.data.fare.inbound.listSegment.length > 1) {
                                        pnrDetailsRes_2.data.fare.inbound.listSegment.map(function (seg) {
                                            if (res.segment.includes(seg.idInfoSegment.toString())) {
                                                tempMealSegments_2.push(seg);
                                            }
                                        });
                                    }
                                }
                            }
                        });
                        mealSegments_2 = tempMealSegments_2;
                        break;
                    case 'O':
                        pnrDetailsRes_2.data.fare.listOutbound.map(function (data) {
                            data.listSegment.map(function (seg) {
                                if (ancMealSegments_2.includes(seg.idInfoSegment.toString())) {
                                    mealSegments_2.push(seg);
                                }
                            });
                        });
                        break;
                    case 'M':
                        pnrDetailsRes_2.data.fare.listOutbound.map(function (data) {
                            data.listSegment.map(function (seg) {
                                if (ancMealSegments_2.some(function (anc) { return anc.segment == seg.idInfoSegment.toString(); })) {
                                    mealSegments_2.push(seg);
                                }
                            });
                        });
                        break;
                    default: break;
                }
                var snackSegment = mealSegments_2;
                this.INDRA_updateStops(snackSegment, "SNACK");
            }
        }
    };
    INDRAFlightDetailsMealsComponent.prototype.INDRA_updateStops = function (mealSegmentsData, ancillary) {
        var _this = this;
        // this will update the meals available per stop in flight based on generate API response when in review page
        if (this.stops && mealSegmentsData) {
            mealSegmentsData.forEach(function (segment) {
                var departure = segment.departureAirport;
                var arrival = segment.arrivalAirport;
                _this.stops.forEach(function (stop) {
                    var airportsArr = stop.label.split('-');
                    if (airportsArr[0] === departure && airportsArr[1] === arrival) {
                        stop.anc = ancillary;
                        stop.available = true;
                    }
                });
            });
        }
    };
    INDRAFlightDetailsMealsComponent.prototype.INDRA_gotoURL = function (key) {
        var languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
        var languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
        var marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
        var urlNavigate = urlIbeAdmin.replace('${lang}', "" + languageMap).replace('${market}', "" + marketCode);
        return window.open(urlNavigate);
    };
    INDRAFlightDetailsMealsComponent.prototype.INDRA_hasInfant = function () {
        if (this.passengerList) {
            var infants = this.passengerList.filter(function (passenger) { return passenger.type === PAX_TYPE_INFANT_CODE; });
            return (infants.length > 0);
        }
        return false;
    };
    /* show special meals section with text and button (applicable for review page flow only) */
    INDRAFlightDetailsMealsComponent.prototype.INDRA_showAddButton = function (flight, flightIdentifier) {
        var ancillaryAvailable = this.bookingService.INDRA_isAncillaryCatalogAvailableForBooking(ANCILLARY_PRODUCT_MEAL, flight);
        var ancillaryBookable = this.bookingService.INDRA_isAncillaryAvailable(EXTRAS_ANCILLARY_MEAL, flightIdentifier);
        var isCodeshare = this.bookingService.INDRA_checkIfCodeShare(flight.listSegment);
        if (ancillaryAvailable && ancillaryBookable && !isCodeshare) {
            this.showAddButton = true;
        }
    };
    // SIDEBAR INTERACTIONS
    /** Close sidebar and clear secondary route */
    INDRAFlightDetailsMealsComponent.prototype.closeSidebar = function () {
        this.sidebarService.closeSidebar();
        this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
    };
    /** Handles close action intention **/
    INDRAFlightDetailsMealsComponent.prototype.INDRA_handleClose = function () { this.closeSidebar(); };
    INDRAFlightDetailsMealsComponent.prototype.openMealSidebar = function () {
        this.sidebarService.openSidebar(['ancillaries--special-meals', { flight: this.flightIdentifier }]);
    };
    INDRAFlightDetailsMealsComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRAFlightDetailsMealsComponent.prototype.INDRA_isLongHaul = function () {
        if (this.flight && this.flight.listSegment) {
            var flightDuration = this.flight.listSegment[0].duration;
            if (flightDuration) {
                var hours = Math.floor(flightDuration / 60);
                return hours > 4;
            }
        }
        return false;
    };
    INDRAFlightDetailsMealsComponent.prototype.INDRA_printImage = function () {
        var _this = this;
        var image;
        var mealImg;
        var snackImg;
        var selectedStop = this.stops[this.selectedStop];
        if (this.flight) {
            // Display image on Flights page.
            if (this.flightsPage) {
                var flightImage = '';
                if (selectedStop && selectedStop.infoSeg) {
                    flightImage = selectedStop.mealImageBySegment && selectedStop.mealImageBySegment !== null && selectedStop.mealImageBySegment[selectedStop.value]
                        ? selectedStop.mealImageBySegment[selectedStop.value]
                        : '';
                }
                else {
                    flightImage = selectedStop.mealImage;
                }
                image = flightImage ? flightImage : '';
            }
            else {
                // Display image on Review your trip page & TTT.	
                if (selectedStop && selectedStop.infoSeg) {
                    var activeBooking = this.bfmStorage.INDRA_getActiveBookedTrip()['fare-information'][this.flight.idFlight];
                    image = activeBooking.mealImageBySegment !== null ? activeBooking.mealImageBySegment[+selectedStop.infoSeg] : '';
                }
                else {
                    var filterMealImg = this.mealImagePerSegment.filter(function (item) { return item.flightId == _this.flight.idFlight.toString() && item.type === "MEALS"; });
                    var filterSnackImg = this.mealImagePerSegment.filter(function (item) { return item.flightId === _this.flight.idFlight.toString() && item.type === "SNACK"; });
                    mealImg = filterMealImg.length > 0 ? filterMealImg[0].image : '';
                    snackImg = filterSnackImg.length > 0 ? filterSnackImg[0].image : '';
                    image = selectedStop && selectedStop.anc === "MEALS" ? mealImg : snackImg;
                }
            }
            return 'url(assets/images/ancillaries/includes/' + image + ')';
        }
        else {
            return null;
        }
    };
    INDRAFlightDetailsMealsComponent.prototype.INDRA_getLevel = function (hours) {
        if (hours < 1.5)
            return 1;
        else if (hours < 4)
            return 2;
        else
            return 3;
    };
    // check if all segments has stopover
    INDRAFlightDetailsMealsComponent.prototype.INDRA_checkStopovers = function () {
        var stopOverFoundFlag = false;
        var bookedTrip = this.bfmStorage.INDRA_getActiveBookedTrip();
        var outbounds = bookedTrip.data.fare.listOutbound;
        var outboundLength = bookedTrip.data.fare.listOutbound.length;
        for (var i = 0; i < outboundLength; i++) {
            if (outbounds[i].isStopOver) {
                stopOverFoundFlag = true;
                break;
            }
        }
        // check stopover on inbound flights
        if (!stopOverFoundFlag && bookedTrip.data.fare.listInbound) {
            var inbounds = bookedTrip.data.fare.listInbound;
            var inboundLength = bookedTrip.data.fare.listInbound.length;
            for (var i = 0; i < inboundLength; i++) {
                if (inbounds[i].isStopOver) {
                    stopOverFoundFlag = true;
                    break;
                }
            }
        }
        return stopOverFoundFlag;
    };
    return INDRAFlightDetailsMealsComponent;
}());
export { INDRAFlightDetailsMealsComponent };
